import { Loader, type TLoaderProps } from '@crehana/compass.ui/loader';
import { cn } from '@crehana/compass.ui/v2';
import { useTranslation } from '@crehana/i18n';
import type { LANGUAGES } from '@crehana/ts-types';

export const SectionLoader: React.FC<{
  className?: string;
  withLabel?: boolean;
  size?: TLoaderProps['size'];
}> = ({ className, withLabel, size }) => {
  const { languageCode } = useTranslation();

  const label: Record<LANGUAGES, string> = {
    es: 'Cargando...',
    en: 'Loading...',
    pt: 'Carregando...',
  };

  return (
    <div
      className={cn(
        'tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center tw-h-full tw-w-full',
        className,
      )}
    >
      <Loader size={size} />
      {withLabel && (
        <p className="tw-text-neutral-light-700 tw-font-subtitle4">
          {label[languageCode]}
        </p>
      )}
    </div>
  );
};
